const sortCheckpointsComparator = (a,b) => {
    if( a.sequence > b.sequence) {
        return 1
    }
    else {
        return -1
    }
}

export const sortCheckPointList = ( list) => {
    return list.sort( (a,b) => sortCheckpointsComparator(a,b))
}